import { render } from "./Promotion.vue?vue&type=template&id=53ec0bcd"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"

import "./Promotion.vue?vue&type=style&index=0&id=53ec0bcd&lang=scss"

import exportComponent from "/Users/gray/Desktop/Work_temp/經貿網/web/project/rotate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__